/* Validation Errors */
const errorText = {
    fullName: 'Du må oppgi minst ett fornavn og ett etternavn',
    respondQuestion: 'Du må svare på spørsmålet',
    emailRequired: 'Du må oppgi en e-postadresse',
    emailInvalid: 'Du må oppgi en e-postadresse med gyldig format',
    phoneLength: 'Mobilnummeret må ha 8 siffer',
    ssn: 'Fødselsnummer må ha 11 siffer',
    ssnMatches: 'Fødselsnummer må være gyldig',
    ssnUnique: 'Fødselsnummer må være forskjellig fra hovedlåntaker',
    vehiclePriceRequired: 'Velg kjøpesum',
    vehiclePricePositive: 'Kjøpssummen må være et positivt tall',
    vehiclePriceLow: 'Kjøpesum må være større enn egenkapitalen',
    equityRequired: 'Velg egenkapital',
    equityNegative: 'Egenkapitalen kan ikke være negativ',
    equityMin: 'Egenkapital må være minimum 0,-',
    equityHigh: 'Egenkapital må være mindre enn kjøpesum',
    loanDurationRequired: 'Du må velge nedbetalingstid',
    livingConditionRequired: 'Du må velge boforhold',
    rentalFeeRequired: 'Du må fylle ut leieutgiftene dine',
    rentalFeeLength: 'Leieutgiftene kan ikke ha mer enn 7 siffer',
    employmentRequired: 'Du må velge arbeidsforhold',
    grossIncomeRequired: 'Du må fylle inn din årlige inntekt før skatt',
    grossIncomeMax: 'Du kan ikke velge mer enn 1 000 000 000,-',
    totalDebtRequired: 'Du må fylle inn din totale gjeld',
    totalDebtMax: 'Du kan ikke velge mer enn 1 000 000 000,-',
    tradeInRequired: 'Vennligst besvar spørsmålet',
    tradeInDebtRequired: 'Du må fylle inn din restgjeld på lånet',
    tradeInDebtLength: 'Restgjeld kan ikke ha mer enn 7 siffer',
    regNoRequired: 'Fyll inn riktig registreringsnummer',
    regNoNotValid: 'Feil registreringsnummer for denne type kjøretøy',
    odometerValueRequired: 'Fyll inn riktig kilometerstand',
    odometerValuePositive: 'Kilometerstand må være et positivt tall',
    loanProduct: 'Vennligst velg et gyldig produkt',
    loanType: 'Vennligst velg en gyldig lånetype',
    coApplicantSameAddress: 'Låntaker og medsøker må ha samme bostedsadresse',
    insurance: 'Vennligst velg om du ønsker betalingsforsikring',
    manufacturerRequired: 'Fyll inn riktig produsent',
    modelYearRequired: 'Fyll inn riktig produksjonsår',
    modelRequired: 'Fyll inn riktig bilmodell',

    // Feedback
    feedbackMessageRequired: 'Du må fylle ut tilbakemelding.',
    feedbackMessageMax: 'Du kan maks bruke 500 tegn.',
};
export default errorText;
